<div class="backpage-wrapper">
  <div class="onboarding-list-content-creator">
    <ng-container *ngIf="isOnboardingExternalUser"
      ><div class="external-role-error-container padding s6 all">
        <phx-card class="left-side-card padding s6 all">
          <img
            width="75"
            height="75"
            src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
            alt="orange explanation point"
          />
          <h2>
            Your account is not tied to an external role - contact
            <a href="mailto:mobilecredentials@allegion.com"
              >mobilecredentials&#64;allegion.com</a
            >
            and Allegion will help you complete setup.
          </h2>
        </phx-card>
        <div class="view-info-button-container padding s6 all"></div>
      </div>
    </ng-container>
    <ng-container *ngIf="isOnboardingInternalUser">
      <div class="onboarding-list-container padding s6 all">
        <div class="header">
          <h1>{{ "Onboarding.OnboardingList" | translate }}</h1>
        </div>
        <form [formGroup]="onboardingListForm">
          <div class="OList-main Onboarding-list-table-section">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
              <ng-container matColumnDef="searchAccount">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-form-field
                    class="search-inputs"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>Search by Account # or Name</mat-label>
                    <input
                      matInput
                      placeholder="Company Search..."
                      formControlName="searchAccountControl"
                    />
                  </mat-form-field>
                </th>
                <td mat-cell *matCellDef="let element">
                  <!-- Placeholder cell -->
                </td>
              </ng-container>

              <ng-container matColumnDef="accountNumber">
                <th mat-header-cell *matHeaderCellDef>Account #</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.accountNumber }}
                </td>
              </ng-container>

              <ng-container matColumnDef="accountName">
                <th mat-header-cell *matHeaderCellDef>Account Name</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.accountName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="searchIntegration">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-form-field
                    class="search-inputs"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>Search by Integration</mat-label>
                    <input
                      matInput
                      placeholder="Integration Name..."
                      formControlName="integrationSearchControl"
                    />
                  </mat-form-field>
                </th>
                <td mat-cell *matCellDef="let element">
                  <!-- Placeholder cell -->
                </td>
              </ng-container>

              <ng-container matColumnDef="integrationName">
                <th mat-header-cell *matHeaderCellDef>Integration Name</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.integrationName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="searchProduct">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-form-field
                    class="search-inputs"
                    appearance="outline"
                    floatLabel="always"
                  >
                    <mat-label>Select Product</mat-label>
                    <mat-select
                      matInput
                      placeholder="Select Product"
                      formControlName="categoryControl"
                    >
                      <mat-option value="0">AllProducts</mat-option>
                      <mat-option value="2">API Credentials</mat-option>
                      <mat-option value="3">Employee Badge</mat-option>
                      <mat-option value="4">Student ID</mat-option>
                      <mat-option value="5">Resident Key</mat-option>
                    </mat-select>
                  </mat-form-field>
                </th>
                <td mat-cell *matCellDef="let element">
                  <!-- Placeholder cell -->
                </td>
              </ng-container>

              <ng-container matColumnDef="placeHolder">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element"></td>
              </ng-container>

              <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef>Product Type</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.product }}
                </td>
              </ng-container>

              <ng-container matColumnDef="integrationId">
                <th mat-header-cell *matHeaderCellDef>Integration Id</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.integrationId }}
                </td>
              </ng-container>

              <ng-container matColumnDef="anniversaryDate">
                <th mat-header-cell *matHeaderCellDef>Anniversary Date</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.anniversaryDate | date: "MM/dd/yyyy" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="lastInvoiceDate">
                <th mat-header-cell *matHeaderCellDef>Last Invoice Date</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.lastInvoiceDate | date: "MM/dd/yyyy" }}
                </td>
              </ng-container>

              <!-- Action Items Column -->
              <ng-container matColumnDef="actionIcons">
                <th mat-header-cell *matHeaderCellDef>Update/Delete</th>
                <td mat-cell *matCellDef="let element">
                  <!-- Edit Action Button -->
                  <button
                    mat-icon-button
                    (click)="editItem(element)"
                    matTooltip="Update"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>

                  <!-- Delete Action Button -->
                  <button
                    mat-icon-button
                    (click)="deleteItem(element)"
                    matTooltip="Delete"
                  >
                    <mat-icon>delete_forever</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr
                mat-header-row
                class="custom-header-row"
                *matHeaderRowDef="searchColumns; sticky: true"
              ></tr>

              <tr
                mat-header-row
                class="custom-header-row"
                *matHeaderRowDef="displayedColumns"
              ></tr>

              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <mat-paginator
              [pageSizeOptions]="[10, 20]"
              showFirstLastButtons
              #paginator
            ></mat-paginator>
          </div>
        </form>
      </div>
    </ng-container>
  </div>
</div>
